// libs
import { createContext, useContext } from 'react';

// types
import { BaseCardContent } from '@/modules/content/components/ContentCard/BaseCard/types';

const BaseCardContext = createContext<BaseCardContent | null>(null);

export const useBaseCard = () => {
  const value = useContext(BaseCardContext);

  if (!value) {
    throw new Error('[BaseCardContext] Not initialised');
  }

  return value;
};

export default BaseCardContext;
